"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bluekeelFeed = _interopRequireDefault(require("@bit/bluekeel.feed.search_pad"));

var _EditorialList = _interopRequireDefault(require("./EditorialList"));

var _EditorialCss = _interopRequireDefault(require("./Editorial.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Editorial = function Editorial(_ref) {
  var feedData = _ref.feedData,
      styleVariants = _ref.styleVariants;

  var handleVisualSearch = function handleVisualSearch(e) {
    e.preventDefault();
    window.scrollTo(0, 0);
  };

  var fullRowTitleStyle = Object.assign({}, _EditorialCss.default['contentTitleSpan'], styleVariants['contentTitleSpan']);
  var fullEditorialTitleStyle = Object.assign({}, _EditorialCss.default['editorialTitle'], styleVariants['editorialTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "editorial-blogfeed-component",
    style: _EditorialCss.default.component
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.componentContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.contentTitle
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: fullRowTitleStyle
  }, "Editorial")), /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.articleRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.mainArticleContainer,
    onClick: handleVisualSearch
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: fullEditorialTitleStyle
  }, "Find Credit Using our Visual Search Tool"), /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.imageContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({}, _EditorialCss.default.articleImage, {
      backgroundImage: "url(".concat(_bluekeelFeed.default, ")")
    })
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: _EditorialCss.default.listContainer
  }, /*#__PURE__*/_react.default.createElement(_EditorialList.default, {
    data: feedData,
    styleVariants: styleVariants
  })))));
};

var _default = (0, _radium.default)(Editorial);

exports.default = _default;

//# sourceMappingURL=Editorial.jsx.map